import React from 'react';
import type { RichLine } from '../types/content';
const toneClass: Record<string, string> = {
  default: '',
  navy: 'font-semibold text-ink-900',
  brick: 'font-medium text-brick-500',
  forest: 'font-semibold text-forest-600'
};
type RichTextProps = {
  line: RichLine;
};
export function RichText({
  line
}: RichTextProps) {
  return <>
      {line.map((segment, index) => <span key={index} className={toneClass[segment.tone ?? 'default']} data-id="element-203" data-mp="3f8kxal8sozbw" data-mpi={index}>
          {segment.text}
        </span>)}
    </>;
}